import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function PresentingSection() {
  return <section className="py-24 px-4 bg-[#0a0a0f] relative overflow-hidden" data-id="element-96">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-97"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-99">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/20 text-blue-500 mb-8" data-id="element-100">
            <BookOpen className="w-8 h-8" data-id="element-101" />
          </div>

          <h2 className="text-sm font-bold tracking-widest text-blue-500 uppercase mb-4" data-id="element-102">
            Presentando
          </h2>
          <h3 className="text-4xl md:text-5xl font-black mb-8 leading-tight" data-id="element-103">
            Facebook Ads Andrómeda:
            <br data-id="element-104" />
            <span className="text-gray-300" data-id="element-105">
              10 Secretos para NO Botar Tu Dinero
            </span>
          </h3>

          <div className="text-xl text-gray-400 space-y-6 max-w-3xl mx-auto" data-id="element-106">
            <p data-id="element-107">
              Un e-book corto, directo y aplicable que te enseña qué{' '}
              <strong className="text-white" data-id="element-108">NO hacer</strong> (y qué hacer en
              su lugar) para que el algoritmo pueda operar con la mínima
              interferencia posible.
            </p>
            <p className="font-medium text-white" data-id="element-109">
              No es teoría. No es un curso de 8 horas. No es motivación.
            </p>
            <p data-id="element-110">
              Son 10 secretos prácticos que cambian tu forma de ejecutar
              campañas para que dejes de pagar por aprendizaje eterno.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}